import { SortDirection, SortIcon } from '@app/shared';

export class Sort {
  active: 0 | 1 = 0;
  property: string;
  columnName: string;
  direction?: SortDirection = undefined;
  icon: SortIcon = 'fa fa-sort';

  constructor(params: SortParams) {
    this.active = params.active ? params.active : this.active;
    this.property = params.property;
    this.columnName = params.columnName;
    this.direction = params.direction ? params.direction : this.direction;
    this.icon = params.icon ? params.icon : this.icon;
  }

  setSort = () => {
    if (this.active == 0) {
      this.activate();
      return;
    }
    if (this.active == 1 && this.direction == 'ASC') {
      this.setDirection('DESC');
      this.setIcon();
    } else {
      this.deactivate();
    }
  };

  activate = () => {
    this.active = 1;
    this.setDirection('ASC');
    this.setIcon();
  };

  deactivate = () => {
    this.active = 0;
    this.setDirection(undefined);
    this.setIcon();
  };

  setDirection = (direction: SortDirection) => {
    this.direction = direction;
  };

  setIcon = () => {
    if (!this.direction) {
      this.icon = 'fa fa-sort';
      return;
    }
    this.icon = this.direction == 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down';
  };
}

interface SortParams {
  active?: 0 | 1;
  property: string;
  columnName: string;
  direction?: SortDirection;
  icon?: SortIcon;
}
